// Generated by CoffeeScript 2.7.0
var ExternalMaterial, MaterialLibrary, SelectedMaterial;

import {
  newAlertify
} from 'trunks/vue/admin/components/alert.js';

import LocalMaterial from 'trunks/vue/admin/components/local_material.js';

SelectedMaterial = {
  props: {
    selectMaterials: {
      type: Array
    }
  },
  template: `<div class="selected-material">
  <div class="header-name">显示顺序</div>
  <div class="group-select"
       v-sortable="{ item: '.group-select-item', dragarea: '.item-bg', sortChangedFunc: sortChanged }">
    <div class="group-select-item"
         v-for='(selectMaterial, index) in selectMaterials'
         :key="selectMaterial.id">
      <div class="item-wrapper">
        <button class="icon-btn btn-small" @click="removeItem(index)">
          <i class="slp-times"></i>
        </button>
        <div class="item-bg" :style="{ backgroundImage: 'url(' + _materialUrl(selectMaterial) + ')' }"/>
      </div>
    </div>
  </div>
</div>`,
  methods: {
    removeItem: function(index) {
      return this.$emit('removeItem', index);
    },
    sortChanged: function(currentIndex, targetIndex) {
      return this.$emit('sortChanged', currentIndex, targetIndex);
    },
    _materialUrl: function(material) {
      if (material.id) {
        return `/admin/material/files/${material.id}/download_url?variant=logo`;
      } else {
        return material.download_url;
      }
    }
  }
};

ExternalMaterial = {
  props: {
    materialType: {
      type: String
    }
  },
  template: `<div class="material-external">
  <div v-if='materialType == "image"'>
    <div class="title">图片地址：</div>
    <div class="upload-input" >
      <input type="text" placeholder="请粘贴图片链接" @input='inputChange' v-model.trim='materialUrl' />
      <div class="text error" v-if='urlErrorMessage && materialUrl'>{{ urlErrorMessage }}</div>
    </div>
    <input class="btn-default ensure"
           type="button"
           value="添加"
           :disabled="urlErrorMessage || !materialUrl"
           @click='addMaterialUrl' />
  </div>
  <div v-else>
    <div class="title">视频地址：</div>
    <div class="upload-input" >
      <input type="text" placeholder="请粘贴视频源分享下的代码到输入框中" v-model.trim='materialUrl'/>
      <div class="text">注：仅支持‘通用代码’，如果客户端浏览器支持flash，可以使用‘html代码’</div>
    </div>
  </div>
</div>`,
  data: function() {
    return {
      materialUrl: '',
      urlErrorMessage: ''
    };
  },
  watch: {
    materialUrl: _.debounce(function(newValue) {
      var loadFile;
      if (this.materialType === 'image') {
        loadFile = new Image();
        loadFile.src = this.materialUrl;
        return loadFile.onerror = () => {
          return this.urlErrorMessage = '请输入正确的图片链接';
        };
      } else {
        return this.$emit('videoUrlChanged', newValue);
      }
    }, 1000)
  },
  methods: {
    inputChange: function() {
      return this.urlErrorMessage = '';
    },
    addMaterialUrl: function() {
      var material;
      material = {
        download_url: this.materialUrl
      };
      this.materialUrl = '';
      this.urlErrorMessage = '';
      return this.$emit('addMaterialUrl', material);
    }
  }
};

export default MaterialLibrary = Vue.extend({
  components: {
    'local-material': LocalMaterial,
    'external-material': ExternalMaterial,
    'selected-material': SelectedMaterial
  },
  props: {
    materialType: {
      type: String,
      default: 'image'
    },
    totalSize: {
      type: Number
    },
    editable: {
      type: Boolean
    },
    multiple: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      selected: 'local',
      selectMaterials: []
    };
  },
  template: `<div class="material-library-wrapper justify-box">
  <div class="tab-navs nav reverse" v-if="!editable">
    <div class="nav-item"
         :class="{ active: selected == 'local'}"
         @click='select("local")'>
      <span>本地{{ typeText }}</span>
    </div>
    <div class="nav-item"
         :class="{ active: selected == 'external'}"
         @click='select("external")'>
      <span>外链{{ typeText }}</span>
    </div>
  </div>
  <div class="material-library content justify-box" :class="{'manage': editable}">
    <div class="tab-contents content">
      <local-material v-show="selected == 'local'"
                      ref="localMaterial"
                      :materialType="materialType"
                      :selectMaterials="selectMaterials"
                      :multiple='multiple'
                      :totalSize="totalSize"
                      :editable="editable"
                      @totalSizeChanged="totalSizeFunc"
                      @toggleMaterial="toggleMaterial"
                      @toggleMultiMaterials="toggleMultiMaterials"
                      @selectAll="selectAllFunc"
                      @clearSelected="clearSelectedFunc"
                      @deleteSelected="deleteFunc"
                      @moveMaterials="moveFunc"
                      @typeChanged="typeChangedFunc" />
      <external-material v-if="selected == 'external'"
                         :materialType="materialType"
                         @videoUrlChanged="videoUrlChanged"
                         @addMaterialUrl="addMaterialUrl" />
    </div>
    <selected-material v-if='materialType == "image" && !editable && multiple'
                       :selectMaterials=selectMaterials
                       @removeItem="removeItem"
                       @sortChanged="sortChanged" />
  </div>
</div>`,
  computed: {
    typeText: function() {
      return Skylark.Helpers.getZH_CN(`material.type.${this.materialType}`);
    }
  },
  watch: {
    selectMaterials: function() {
      return this.$emit('materialsChanged', this.selectMaterials);
    }
  },
  methods: {
    select: function(type) {
      return this.selected = type;
    },
    toggleMaterial: function(material) {
      var _exist, ref;
      if (this.materialType === 'video') {
        return this.selectMaterials = ((ref = _.first(this.selectMaterials)) != null ? ref.id : void 0) === material.id ? [] : [material];
      } else {
        _exist = _.some(this.selectMaterials, function(item) {
          return item.id === material.id;
        });
        if (_exist) {
          return this.selectMaterials = _.reject(this.selectMaterials, function(item) {
            return item.id === material.id;
          });
        } else {
          if (this.multiple) {
            return this.selectMaterials.push(material);
          } else {
            return this.selectMaterials = [material];
          }
        }
      }
    },
    toggleMultiMaterials: function(materials) {
      return this.selectMaterials = _.uniq(this.selectMaterials.concat(materials));
    },
    removeItem: function(index) {
      return this.selectMaterials.splice(index, 1);
    },
    addMaterialUrl: function(material) {
      return this.selectMaterials.push(material);
    },
    sortChanged: function(currentIndex, targetIndex) {
      var option;
      if (currentIndex === targetIndex) {
        return;
      }
      option = this.selectMaterials.splice(currentIndex, 1)[0];
      this.selectMaterials.splice(targetIndex, 0, option);
      return this.$emit('valueChanged');
    },
    videoUrlChanged: function(videoUrl) {
      return this.selectMaterials = videoUrl;
    },
    totalSizeFunc: function(totalSize) {
      return this.$emit('totalSizeChanged', totalSize);
    },
    clearSelectedFunc: function() {
      return this.selectMaterials = [];
    },
    selectAllFunc: function(materials) {
      return this.selectMaterials = materials;
    },
    deleteFunc: function(material) {
      var deleteUrl, file_ids;
      file_ids = material ? [material.id] : _.pluck(this.selectMaterials, 'id');
      deleteUrl = Skylark.Helpers.UrlHelper.generateUrlWithParams("/admin/material/files/destroy_collection", {
        file_ids: file_ids
      });
      return Skylark.Libs.Ajax.delete(deleteUrl, {
        success: () => {
          newAlertify('删除成功', {
            type: 'success',
            showIcon: true
          });
          this.$refs.localMaterial.refresh();
          return this.$refs.localMaterial.updateCounts(this.calculate_counts(material));
        },
        error: () => {
          return newAlertify('删除失败', {
            type: 'error',
            showIcon: true
          });
        },
        complete: () => {
          return this.clearSelectedFunc();
        }
      });
    },
    moveFunc: function(target) {
      var data;
      data = {
        material_folder: {
          file_ids: _.pluck(this.selectMaterials, 'id')
        }
      };
      return Skylark.Libs.Ajax.patch(`/admin/material/folders/${target.id}`, {
        data: data,
        contentType: 'application/json; charset=utf-8',
        success: (data) => {
          newAlertify(`移动到${target.name}成功`, {
            type: 'success',
            showIcon: true
          });
          this.$refs.localMaterial.refresh();
          this.$refs.localMaterial.updateCounts(this.calculate_counts());
          return this.$refs.localMaterial.updateCounts(this.calculate_counts(), target);
        },
        error: (xhr, error) => {
          return newAlertify('移动失败', {
            type: 'error',
            showIcon: true
          });
        },
        complete: () => {
          return this.clearSelectedFunc();
        }
      });
    },
    calculate_counts: function(material) {
      var delta_counts;
      delta_counts = {
        images_count: 0,
        videos_count: 0
      };
      if (material) {
        delta_counts[`${material.extension}s_count`] -= 1;
      } else {
        _.each(this.selectMaterials, function(material) {
          return delta_counts[`${material.extension}s_count`] -= 1;
        });
      }
      return delta_counts;
    },
    typeChangedFunc: function(type) {
      return this.$emit('typeChanged', type);
    },
    updateMaterials: function() {
      return this.$refs.localMaterial.updateMaterials();
    }
  }
});
